import React from "react";
import { Box, Typography, Button, Container } from "@mui/material";
import { useNavigate } from "react-router-dom";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";

export default function NotFound() {
    const navigate = useNavigate();

    return (
        <Container maxWidth="md" sx={{ textAlign: "center", py: 10 }}>
            <Box sx={{ mb: 4 }}>
                <ErrorOutlineIcon sx={{ fontSize: 100, color: "text.disabled" }} />
            </Box>
            <Typography variant="h2" fontWeight={800} gutterBottom>
                404
            </Typography>
            <Typography variant="h5" color="var(--cinza)" paragraph>
                Ops! A página que você está procurando não existe.
            </Typography>
            <Button
                variant="contained"
                size="large"
                onClick={() => navigate("/")}
                sx={{ mt: 2, borderRadius: 4, px: 5 }}
            >
                Voltar para o Início
            </Button>
        </Container>
    );
}